export const isProductionEnvironment =
  import.meta.env.VITE_ENVIRONMENT === 'production';

export const isBetaEnvironment = import.meta.env.VITE_ENVIRONMENT === 'beta';

export const isDevelopmentEnvironment =
  import.meta.env.VITE_ENVIRONMENT === 'development';
